<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Bienvenido</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
      <!-- Card Button -->
      <div class="row">
        <div v-if="$can('index', 'visits')" class="col-xl-3 col-md-6">
          <button-card icon="fas fa-calendar-check" route="Visits" sub-title="" title="Visitas" type="gradient-green">
          </button-card>
        </div>
        <div v-if="$can('index', 'plots')" class="col-xl-3 col-md-6">
          <button-card icon="fas fa-seedling" route="PlotsList" sub-title="" title="Lotes" type="gradient-orange">
          </button-card>
        </div>
        <div v-if="$can('index', 'documents')" class="col-xl-3 col-md-6">
          <button-card
            icon="far fa-file-alt"
            route="DocumentsList"
            sub-title=""
            title="Documentos"
            type="gradient-gray-dark"
          >
          </button-card>
        </div>
        <div v-if="$can('index', 'orders')" class="col-xl-3 col-md-6">
          <button-card icon="fas fa-box-open" route="OrdersList" sub-title="" title="Pedidos" type="yellow">
          </button-card>
        </div>
        <div v-if="$can('index', 'quotations')" class="col-xl-3 col-md-6">
          <button-card
            icon="far fa-file-alt"
            route="QuotationsList"
            sub-title=""
            title="Cotizaciones"
            type="gradient-purple"
          >
          </button-card>
        </div>
        <!--         d-inline-block d-sm-none     para mostrar solo en cellphone-->
        <div v-if="$can('index', 'producers')" class="col-xl-3 col-md-6 col-sm-6 col-xs-6">
          <button-card icon="fas fa-tractor" route="ProducersList" sub-title="" title="Productores" type="gradient-red">
          </button-card>
        </div>
        <div v-if="$can('index', 'projections')" class="col-xl-3 col-md-6 col-sm-6 col-xs-6">
          <button-card
            icon="fas fa-chart-line"
            route="ProjectionsList"
            sub-title=""
            title="Proyecciones"
            type="gradient-gray"
          >
          </button-card>
        </div>
        <div v-if="$can('index', 'plots')" class="col-xl-3 col-md-6 col-sm-6 col-xs-6">
          <button-card
            icon="fas fa-chart-bar"
            route="ProjectionCharts"
            title="Graficos"
            badge-color="bg-red"
            type="gradient-teal"
          >
          </button-card>
        </div>
        <div v-if="$can('articles', 'stocks')" class="col-xl-3 col-md-6 col-sm-6 col-xs-6">
          <button-card
            icon="fas fa-box"
            route="StockByArticle"
            title="Stock General"
            badge-color="bg-red"
            type="gradient-dark"
          >
          </button-card>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-12">
          <visits-table
            v-if="$can('index', 'visits')"
            :limit="5"
            :show-filters="false"
            :show-pagination="false"
            cy-id="visits-table"
            title="Ultimas visitas"
          ></visits-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import ButtonCard from '@/components/Cards/ButtonCard';

// Tables
import VisitsTable from '@/views/Visits/List/VisitsTable';

export default {
  name: 'Dashboard',
  components: {
    RouteBreadCrumb,
    ButtonCard,
    VisitsTable,
  },
};
</script>
